import { render, staticRenderFns } from "./TaskOnboardee.vue?vue&type=template&id=6b92d7bf&scoped=true"
import script from "./TaskOnboardee.vue?vue&type=script&lang=js"
export * from "./TaskOnboardee.vue?vue&type=script&lang=js"
import style0 from "./TaskOnboardee.vue?vue&type=style&index=0&id=6b92d7bf&prod&lang=scss"
import style1 from "./TaskOnboardee.vue?vue&type=style&index=1&id=6b92d7bf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b92d7bf",
  null
  
)

export default component.exports